// extracted by mini-css-extract-plugin
module.exports = {"addToCartButton":"AddToCartButton_addToCartButton__I9PQY","standaloneButton":"AddToCartButton_standaloneButton__taNAk"};